export enum TaskStatus {
  Pending = 1,
  Completed = 2,
  Differed = 3,
  Cancelled = 4
}
